import { ReactElement } from 'react';
import { CircularProgress } from '@mui/material';

import { DialogAssingBillingListProps } from './types';
import DialogAssingBillingListProvider, {
  useDialogAssingBillingListContext,
} from './DialogAssingBillingListContext';
import DialogAssingBillingListContent from './Content';
import {
  DialogAssingBillingListContainer,
  DialogAssingBillingListLoadingContainer,
} from './styles';

const DialogAssingBillingList = (): ReactElement => {
  const { open, loadingActiveBillingLists } =
    useDialogAssingBillingListContext();

  return (
    <DialogAssingBillingListContainer open={open}>
      {loadingActiveBillingLists && (
        <DialogAssingBillingListLoadingContainer>
          <CircularProgress color="primary" disableShrink size={80} />
        </DialogAssingBillingListLoadingContainer>
      )}

      {!loadingActiveBillingLists && <DialogAssingBillingListContent />}
    </DialogAssingBillingListContainer>
  );
};

const WrappedDialogAssingBillingList = ({
  open,
  onClose,
  onConfirm,
  loadinConfirm,
}: DialogAssingBillingListProps): ReactElement => {
  return (
    <DialogAssingBillingListProvider
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      loadinConfirm={loadinConfirm}
    >
      <DialogAssingBillingList />
    </DialogAssingBillingListProvider>
  );
};

export default WrappedDialogAssingBillingList;
